<template>
  <div class="mediation-list-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>人民调解管理</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-select v-model="conditions.state" placeholder="案件状态" clearable style="width:100%">
            <el-option v-for="item in stateOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-input v-model="conditions.committeeId" placeholder="调委会ID" />
        </el-col>
        <el-col :span="4">
          <el-input v-model="conditions.caseId" placeholder="案件编号" />
        </el-col>
        <el-col :span="8">
          <el-date-picker
            v-model="timeRange"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            style="width:100%"
            :default-time="['00:00:00','23:59:59']"
          />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_loadList">查询</el-button>
          <el-button @click="_resetConditions">重置</el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card style="margin-top:20px">
      <div slot="header">
        <span>案件列表</span>
        <span class="legend-tip">
          <span class="legend-color red"></span>表示超时
          <span class="legend-tip-text">（受理超3工作日 / 调解超30日）</span>
        </span>
      </div>
      <el-table :data="tableData" border v-loading="loading" :row-class-name="_rowClassName" style="width:100%">
        <el-table-column prop="caseId" label="案件编号" align="center" width="180" />
        <el-table-column prop="disputeType" label="纠纷类别" align="center" />
        <el-table-column prop="committeeName" label="调委会" align="center" show-overflow-tooltip />
        <el-table-column prop="applyUserName" label="申请人" align="center" />
        <el-table-column label="案件状态" align="center" width="120">
          <template slot-scope="scope">
            <el-tag :type="_stateTagType(scope.row.state)">{{ _stateName(scope.row.state) }}</el-tag>
            <span v-if="_isTimeout(scope.row)" class="timeout-tip">超时</span>
          </template>
        </el-table-column>
        <el-table-column prop="mediatorName" label="调解员" align="center" />
        <el-table-column prop="createTime" label="创建时间" align="center" width="170" />
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button-group>
              <el-button size="mini" @click="_toDetail(scope.row)">详情</el-button>
              <el-button
                v-if="scope.row.state === 'PENDING'"
                size="mini"
                type="primary"
                @click="_toAudit(scope.row)"
              >受理审查</el-button>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top:20px;text-align:right"
        background
        @current-change="_handlePageChange"
        :current-page="conditions.page"
        :page-size="conditions.row"
        :total="total"
        layout="total, prev, pager, next, jumper"
      />
    </el-card>

    <!-- 受理审查 弹窗 -->
    <el-dialog title="受理审查" :visible.sync="auditDialog.visible" width="500px" :close-on-click-modal="false">
      <el-form :model="auditDialog" label-width="100px">
        <el-form-item label="案件编号">
          <span>{{ auditDialog.caseId }}</span>
        </el-form-item>
        <el-form-item label="审核结果">
          <el-radio-group v-model="auditDialog.auditResult">
            <el-radio label="PASS">受理通过</el-radio>
            <el-radio label="REJECT">不予受理</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="auditDialog.auditResult === 'PASS'" label="调解员">
          <el-select
            v-model="auditDialog.mediatorId"
            placeholder="选填：通过后立即指派调解员"
            filterable
            clearable
            style="width:100%"
            @change="_onAuditMediatorChange"
          >
            <el-option
              v-for="m in auditDialog.mediatorOptions"
              :key="m.staffId"
              :label="m.staffName + '（' + m.staffId + '）'"
              :value="m.staffId"
            />
          </el-select>
          <div v-if="auditDialog.mediatorOptions.length === 0" style="color:#909399;font-size:12px;margin-top:4px">
            未选择调解员则通过后处于「受理中」，可稍后在详情中指派
          </div>
        </el-form-item>
        <el-form-item label="审核意见">
          <el-input type="textarea" v-model="auditDialog.remark" :rows="4" placeholder="请填写审核意见" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="_submitAudit" :loading="auditDialog.submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listMediationCases,
  auditMediationApply,
  assignMediator,
  listDisputeTypes,
  stateToName,
  stateToTagType
} from '@/api/oa/mediationApi'

const PENDING_STATES = ['ACCEPTED', 'SCHEDULED', 'IN_PROGRESS']

export default {
  name: 'MediationList',
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      conditions: {
        page: 1,
        row: 20,
        state: '',
        committeeId: '',
        caseId: '',
        startTime: '',
        endTime: ''
      },
      timeRange: [],
      stateOptions: [
        { label: '待受理', value: 'PENDING' },
        { label: '受理中', value: 'ACCEPTED' },
        { label: '调解排期', value: 'SCHEDULED' },
        { label: '调解进行中', value: 'IN_PROGRESS' },
        { label: '达成协议', value: 'AGREED' },
        { label: '调解终止', value: 'TERMINATED' },
        { label: '已归档', value: 'ARCHIVED' }
      ],
      auditDialog: {
        visible: false,
        caseId: '',
        auditResult: 'PASS',
        remark: '',
        mediatorId: '',
        mediatorName: '',
        mediatorOptions: [],
        submitting: false
      }
    }
  },
  mounted() {
    this._loadList()
  },
  methods: {
    _stateName: stateToName,
    _stateTagType: stateToTagType,
    _handlePageChange(page) {
      this.conditions.page = page
      this._loadList()
    },
    _resetConditions() {
      this.conditions = {
        page: 1,
        row: 20,
        state: '',
        committeeId: '',
        caseId: '',
        startTime: '',
        endTime: ''
      }
      this.timeRange = []
      this._loadList()
    },
    _loadList() {
      if (this.timeRange && this.timeRange.length === 2) {
        this.conditions.startTime = this.timeRange[0]
        this.conditions.endTime = this.timeRange[1]
      } else {
        this.conditions.startTime = ''
        this.conditions.endTime = ''
      }
      this.loading = true
      listMediationCases(this.conditions).then(res => {
        const data = res.data || {}
        this.tableData = data.cases || []
        this.total = data.total || 0
      }).catch(() => {
        this.tableData = []
        this.total = 0
      }).finally(() => {
        this.loading = false
      })
    },
    _toDetail(row) {
      this.$router.push({ path: '/oa/mediationDetail', query: { caseId: row.caseId } })
    },
    _toAudit(row) {
      this.auditDialog.caseId = row.caseId
      this.auditDialog.auditResult = 'PASS'
      this.auditDialog.remark = ''
      this.auditDialog.mediatorId = ''
      this.auditDialog.mediatorName = ''
      this.auditDialog.mediatorOptions = []
      this.auditDialog.visible = true
      this._loadAuditMediators(row.disputeTypeId)
    },
    /**
     * 根据案件纠纷类型ID加载关联调解员列表（受理通过后可选择立即指派）
     */
    _loadAuditMediators(typeId) {
      if (!typeId) {
        this.auditDialog.mediatorOptions = []
        return
      }
      listDisputeTypes({}).then(res => {
        const d = res.data || res || {}
        const types = d.disputeTypes || []
        const t = types.find(x => x.typeId === typeId)
        if (t && t.mediators) {
          this.auditDialog.mediatorOptions = t.mediators.map(m => ({
            staffId: m.staffId,
            staffName: m.staffName || m.staffId
          }))
        }
      }).catch(() => {
        // 忽略
      })
    },
    _onAuditMediatorChange(val) {
      const opt = this.auditDialog.mediatorOptions.find(o => o.staffId === val)
      this.auditDialog.mediatorName = opt ? opt.staffName : ''
    },
    _submitAudit() {
      if (!this.auditDialog.remark) {
        this.$message.error('请填写审核意见')
        return
      }
      this.auditDialog.submitting = true
      const params = {
        caseId: this.auditDialog.caseId,
        auditResult: this.auditDialog.auditResult,
        remark: this.auditDialog.remark
      }
      auditMediationApply(params).then(() => {
        // 审核通过且选择了调解员时，紧接着指派调解员
        if (this.auditDialog.auditResult === 'PASS' && this.auditDialog.mediatorId) {
          return assignMediator({
            caseId: this.auditDialog.caseId,
            mediatorId: this.auditDialog.mediatorId,
            mediatorName: this.auditDialog.mediatorName
          })
        }
      }).then(() => {
        this.$message.success('审核完成')
        this.auditDialog.visible = false
        this._loadList()
      }).catch(err => {
        this.$message.error(err || '审核失败')
      }).finally(() => {
        this.auditDialog.submitting = false
      })
    },
    // 超时判断：受理超3工作日（state=PENDING 且 createTime>3工作日）
    // 调解超30日（state in ACCEPTED/SCHEDULED/IN_PROGRESS 且 createTime>30天）
    _isTimeout(row) {
      if (!row.createTime) return false
      const createMs = new Date(row.createTime).getTime()
      if (isNaN(createMs)) return false
      const now = Date.now()
      const diffDays = (now - createMs) / (24 * 3600 * 1000)
      if (row.state === 'PENDING') {
        // 3工作日 ≈ 5自然日（粗略）
        return diffDays > 5
      }
      if (PENDING_STATES.indexOf(row.state) >= 0) {
        return diffDays > 30
      }
      return false
    },
    _rowClassName({ row }) {
      return this._isTimeout(row) ? ' mediation-row-timeout' : ''
    }
  }
}
</script>

<style>
.mediation-list-container {
  padding: 20px;
}

.legend-tip {
  margin-left: 20px;
  font-size: 13px;
  color: #999;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  background-color: #f56c6c;
  border-radius: 2px;
  margin-right: 6px;
  vertical-align: middle;
}

.legend-tip-text {
  color: #bbb;
  font-size: 12px;
  margin-left: 6px;
}

.timeout-tip {
  margin-left: 6px;
  color: #f56c6c;
  font-size: 12px;
  font-weight: bold;
}

.mediation-row-timeout {
  background-color: #fef0f0 !important;
}

.mediation-row-timeout:hover > td {
  background-color: #fde2e2 !important;
}
</style>
